import { render, staticRenderFns } from "./AppInstallPrompt.vue?vue&type=template&id=558d8aae&scoped=true"
import script from "./AppInstallPrompt.vue?vue&type=script&lang=js"
export * from "./AppInstallPrompt.vue?vue&type=script&lang=js"
import style0 from "./AppInstallPrompt.vue?vue&type=style&index=0&id=558d8aae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "558d8aae",
  null
  
)

export default component.exports